import { render, staticRenderFns } from "./AdminCopperCate1.vue?vue&type=template&id=2c2842f0&scoped=true&"
import script from "./AdminCopperCate1.vue?vue&type=script&lang=js&"
export * from "./AdminCopperCate1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2842f0",
  null
  
)

export default component.exports